export default "__VITE_ASSET__CBbipotq__"